import React from 'react';
import { useSelector } from 'react-redux';
import { OrdersGridPrintDocumentButton } from '../../../../components/orders-grid/print-document-button';
import style from './add-order-to-batch-or-print.module.less';
import OrdersDrawerAddToBatchDropdownContainer from '../../../add-to-batch-dropdown/orders-drawer-add-to-batch-dropdown.container';
import { useContainsDemoOrder } from '../../../../demos/hooks/use-contains-demo-order';
import Global from '../../../../store/global-selectors';

const BatchOrPrint = () => {
  const selectedOrderIds = useSelector(Global.selectSelectedOrdersIds) || [];
  const isDemoOrder = useContainsDemoOrder(selectedOrderIds);
  return (
    <div className={style['add-order-to-batch-or-print-container']}>
      {!isDemoOrder && <OrdersDrawerAddToBatchDropdownContainer />}
      <div className={style['print-from-drawer']}>
        <OrdersGridPrintDocumentButton />
      </div>
    </div>
  );
};

export default BatchOrPrint;
